module.exports = __webpack_public_path__ + "img/programming.24a60125.svg";